import {useContext} from 'react';
import {StudentContext} from 'context/Student.context';
import IMG from 'assets/profile-picture.png';
import './styles.less';
import {Descriptions, Tooltip} from 'antd';
import useMediaQuery from 'hooks/useMediaQuery.hook';

const MainCard = ({showExternalInfo = true}: {showExternalInfo?: boolean}) => {
	const {
		state: {
			name,
			lastName,
			email,
			courseName,
			facultyName,
			flowName,
			path,
			currentStatusName,
			studentAccountingNumber,
			studentCode,
			studentLyon3Number,
			discount,
			progressDiscount,
			socialDiscount,
			otherDiscount
		}
	} = useContext(StudentContext);

	const isVertical = useMediaQuery('(max-width: 1444px)');

	return (
		<div className="student-main-card">
			{showExternalInfo && (
				<div className="photo">
					<img
						className="student-photo"
						src={path ? process.env.REACT_APP_API_URL + '/' + path : IMG}
						width={168}
					/>
					<h2>
						{name} {lastName}
					</h2>
				</div>
			)}
			<Descriptions
				bordered
				layout={isVertical ? 'vertical' : 'horizontal'}
				colon={false}
				column={{lg: showExternalInfo ? 3 : 1, xs: 1, sm: 1}}
				size={'small'}>
				<Descriptions.Item label="Գրանցման համար՝">{studentAccountingNumber}</Descriptions.Item>
				<Descriptions.Item label="Ուսանողական կոդ՝">{studentCode}</Descriptions.Item>
				<Descriptions.Item label="Lyon3 համար՝">{studentLyon3Number}</Descriptions.Item>
				<Descriptions.Item label="Կարգավիճակ՝">{currentStatusName}</Descriptions.Item>
				<Descriptions.Item label="Էլ․ հասցե՝">{email}</Descriptions.Item>
				<Descriptions.Item label="Ֆակուլտետ՝">{facultyName}</Descriptions.Item>
				<Descriptions.Item label="Կուրս՝">{courseName}</Descriptions.Item>
				<Descriptions.Item label="Հոսք՝">{flowName}</Descriptions.Item>
				<Descriptions.Item label="Զեղչ">
					<Tooltip
						overlayStyle={{whiteSpace: 'pre-line'}}
						title={`
						Առաջադիմության զեղչ՝ ${progressDiscount || 0} \n
						Սոցիալական զեղչ՝ ${socialDiscount || 0} \n
						Այլ զեղչ՝ ${otherDiscount || 0} \n
					`}>
						{discount}
					</Tooltip>
				</Descriptions.Item>
			</Descriptions>
		</div>
	);
};

export default MainCard;
